export interface IncompleteGpAddressTableData {
  gpaddress_id: string;
  visit_id: string;
  service: string;
  medications: string[];
  editMode: boolean;
  is_verified: boolean;
  status_id: GpAddressStatus;
  surgery_name: string;
  line_1: string;
  line_2: string;
  line_3: string;
  town: string;
  postcode: string;
  created: string;
  noOfContacts: number;
  lastContacted: string;
  selected: boolean;
  printed: boolean;
  clone: IncompleteGpAddressTableDataClone;
}
export interface IncompleteGpAddressTableDataClone {
  gpaddress_id: string;
  visit_id: string;
  service: string;
  medications: string[];
  editMode: boolean;
  is_verified: boolean;
  status_id: GpAddressStatus;
  surgery_name: string;
  line_1: string;
  line_2: string;
  line_3: string;
  town: string;
  postcode: string;
  created: string;
  noOfContacts: number;
  lastContacted: string;
}

export enum GpAddressStatus {
  pending = 1,
  verified,
  incomplete,
  unresponsive,
}

export enum GpAddressVerifiedStatus {
  notVerified = 0,
  verified,
}
